import styled from "styled-components";
import { COLORS, FONT_SIZE, FONTS } from "../../constants/Styles";

export const AddCollaboratorForm = styled.form`
  display: flex;
  flex-direction: column;
`;

export const Description = styled.div`
  margin: 1rem 0;
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size14};
`;

export const CollaboratorsContainer = styled.div`
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid ${COLORS.inputGray};
`;

export const CollaboratorsList = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const CollaboratorItem = styled.div`
  height: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${COLORS.secondaryLight};
`;

export const Title = styled.div`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size18};
`;

export const ButtonsRow = styled.div`
  display: flex;
  margin-top: 1rem;
  justify-content: center;
  gap: 1rem;
`;
